import PaymentMethodSelector from './PaymentMethodSelector';

export default PaymentMethodSelector;
